import React from "react";
import LeftBlock from './footer/LeftBlock';
import RightBlock from './footer/RightBlock';
import CookieBanner from './footer/CookieBanner';

export default class Footer extends React.PureComponent {
    render() {
        let { isCookieBannerShow, closeCookieBanner } = this.props;

        return (
            <div className={'footer'}>
                <CookieBanner isCookieBannerShow={isCookieBannerShow} closeCookieBanner={closeCookieBanner}/>

                <LeftBlock/>

                <RightBlock/>
            </div>
        );
    }
}

